import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  messages: [],
  clearAns:false
};

const chatHistorySlice = createSlice({
  name: "chatHistory",
  initialState,
  reducers: {
    setChatHistory: (state, action) => {
    
      
       //  old chat merge with new chat
  const newMessages = action.payload;

  const allMessages = [...state.messages, ...newMessages]; 

      //  Unique messages based on timestamp
  const uniqueMessages = allMessages.filter(
    (msg, index, self) => index === self.findIndex((m) => m.timestamp === msg.timestamp)
  );

      state.messages = uniqueMessages; //store unique messages 
    },
    // clearChatHistory: (state) => {
    //   state.messages = []; //  Redux state reset 
    // },
    clearChatWindow: (state) => {
      state.messages = []; //  only clear chat window  
    },
    setClearAns: (state, action) => {
      state.clearAns = action.payload; //  Manually control `clearAns`
    },
    setChatMessages: (state, action) => {
    
      state.messages = action.payload; // update old messages   
    },
  },
});

export const { setChatMessages,setChatHistory, clearChatWindow ,setClearAns} = chatHistorySlice.actions;
export default chatHistorySlice.reducer;
